const scaler_transform = (x, modelData) => {
    const mean = modelData.scaler.mean[0];
    const std = modelData.scaler.std[0];
    return (x - mean) / std;
}

const poly_transform = (x, modelData) => {
    const degrees = modelData.poly.degrees;
    return Array.from({ length: degrees + 1 }, (_, i) => x ** i);
}

const linear_transform = (x, modelData) => {
    const coef = modelData.linear.coef;
    const intercept = modelData.linear.intercept;
    return x.reduce((acc, val, i) => acc + val * coef[i], intercept);
}

export const polyModelTransform = (x, modelData): number[] => {
    const x_scaled = x.map(v => scaler_transform(v, modelData));
    const x_poly = x_scaled.map(v => poly_transform(v, modelData));
    return x_poly.map(v => linear_transform(v, modelData));
}
